import {HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

import {RequestService} from '@atmi/core/services/request.service';
import {TelemetryService} from '@atmi/core/services/telemetry.service';
import {catchError, map} from "rxjs/operators";
import {throwError} from "rxjs";

//https://angular.io/guide/http-intercept-requests-and-responses

@Injectable()
export class RequestInterceptorService implements HttpInterceptor {

  constructor(
    private readonly requestService: RequestService,
    private readonly router: Router,
    private readonly telemetry: TelemetryService,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // don't want to store GET and login request
    // FIXME: improve check passing a factory
    if (
      req.method !== 'GET' &&
      req.method !== 'OPTIONS' &&
      !req.url.includes('/sessions') &&
      !req.url.includes('/telemetry/')
    ) {
      this.requestService.unsetError();
      this.requestService.setRequest(req);
      return next.handle(req).pipe(
        map((event) => {
          if (event instanceof HttpResponse) {
            this.requestService.clearState();
          }
          return event;
        }),
        catchError((error) => {
          console.error('error in interceptor:', error);
          this.requestService.setError(error);
          this.telemetry.reportError(error, `${req.method} ${req.url}`);

          // Handle 401 Unauthorized - clear localStorage and redirect to login
          if (error.status === 401) {
            console.warn('401 Unauthorized - clearing session and redirecting to login');
            localStorage.clear();
            this.router.navigate(['/login']);
          }

          return throwError(() => error);
        })
      )
    }

    return next.handle(req);

  }

  /*on req completed this.requestService.clearState() and this.requestService.setError() in case of error*/
}
